import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  static DISMISS_DELAY_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

  connect() {
    if (localStorage.getItem("pwa-installed") === "true") {
      this.hideBanner()
      return
    }

    const dismissedAt = localStorage.getItem("pwa-dismissed-at")
    if (dismissedAt && (Date.now() - Number(dismissedAt)) < this.constructor.DISMISS_DELAY_MS) {
      this.hideBanner()
      return
    }

    this.abortController = new AbortController()
    const signal = this.abortController.signal

    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault()
      this.deferredPrompt = event
      this.showBanner()
    }, { signal })

    window.addEventListener("appinstalled", () => {
      this.markInstalled()
    }, { signal })
  }

  disconnect() {
    this.abortController?.abort()
    this.deferredPrompt = null
  }

  async install() {
    if (!this.deferredPrompt) return

    this.deferredPrompt.prompt()
    const { outcome } = await this.deferredPrompt.userChoice

    if (outcome === "accepted") {
      this.markInstalled()
    } else {
      this.dismiss()
    }

    this.deferredPrompt = null
  }

  dismiss() {
    localStorage.setItem("pwa-dismissed-at", String(Date.now()))
    this.hideBanner()
  }

  showBanner() {
    if (this.hasBannerTarget) {
      this.bannerTarget.removeAttribute("hidden")
    }
  }

  hideBanner() {
    if (this.hasBannerTarget) {
      this.bannerTarget.setAttribute("hidden", "")
    }
  }

  markInstalled() {
    localStorage.setItem("pwa-installed", "true")
    this.hideBanner()
  }
}
